var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34_348)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FAC95D",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.19048,
    y: 0.190476,
    width: 35.619,
    height: 35.619,
    rx: 17.8095,
    stroke: "black",
    strokeWidth: 0.380952,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_34_348",
    maskUnits: "userSpaceOnUse",
    x: 12.5,
    y: 9.5,
    width: 15,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 12.5,
    y: 9.5,
    width: 15,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8568 27.5H18.1432V13.0771H13.3875V9.98646H26.6125V13.0771H21.8568V27.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.8568 27.5H18.1432V13.0771H13.3875V9.98646H26.6125V13.0771H21.8568V27.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8568 27.5V27.881H22.2377V27.5H21.8568ZM18.1432 27.5H17.7623V27.881H18.1432V27.5ZM18.1432 13.0771H18.5242V12.6961H18.1432V13.0771ZM13.3875 13.0771H13.0065V13.458H13.3875V13.0771ZM13.3875 9.98646V9.6055H13.0065V9.98646H13.3875ZM26.6125 9.98646H26.9935V9.6055H26.6125V9.98646ZM26.6125 13.0771V13.458H26.9935V13.0771H26.6125ZM21.8568 13.0771V12.6961H21.4758V13.0771H21.8568ZM21.8568 27.119H18.1432V27.881H21.8568V27.119ZM18.5242 27.5V13.0771H17.7623V27.5H18.5242ZM18.1432 12.6961H13.3875V13.458H18.1432V12.6961ZM13.7685 13.0771V9.98646H13.0065V13.0771H13.7685ZM13.3875 10.3674H26.6125V9.6055H13.3875V10.3674ZM26.2315 9.98646V13.0771H26.9935V9.98646H26.2315ZM26.6125 12.6961H21.8568V13.458H26.6125V12.6961ZM21.4758 13.0771V27.5H22.2377V13.0771H21.4758Z",
    fill: "black",
    mask: "url(#path-3-outside-1_34_348)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34_348",
    x: 0.47619,
    y: 0,
    width: 39.0476,
    height: 39.0476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.52381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.761905
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_348",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT);
export default __webpack_public_path__ + "static/media/T.9821eaa41482811c1422b2d6923d1b5b.svg";
export { ForwardRef as ReactComponent };